// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2YN_l","search":"Settings_search__J0nFe","filter":"Settings_filter__388um"};